import React, { useCallback, useState } from 'react';
import ItemSlider from '@react/component/item-slider';
import ItemThumbnailNav from '@react/component/item-thumbnail-nav';
const ItemBox = ({ itemList }) => {
    const [swiper, setSwiper] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    // Swiperの初期化
    const onSwiper = useCallback((swiper) => {
        setSwiper(swiper);
    }, [
        itemList
    ]);
    // スライドの切り替えハンドラ
    const onSlideChange = useCallback((swiper) => {
        setActiveIndex(swiper.activeIndex);
    }, [
        itemList
    ]);
    // サムネイルのクリックハンドラ
    const onThumbnailClick = useCallback((index) => {
        if (swiper) {
            swiper.slideTo(index);
        }
    }, [
        itemList,
        swiper
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "panel-main" },
            React.createElement(ItemSlider, { itemList: itemList, onSlideChange: onSlideChange, onSwiper: onSwiper })),
        itemList.length > 1 &&
            React.createElement("ul", { className: "panel-thumbnail" },
                React.createElement(ItemThumbnailNav, { itemList: itemList, activeIndex: activeIndex, onThumbnailClick: onThumbnailClick }))));
};
export default ItemBox;
